'use strict';

import { flow, observable, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import {find} from 'underscore';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import feedbackMessagesStore from '@uw-it-sis/lib-react/lib/FeedbackMessagesStore';
import api from "../lib/Api";

/**
 * Store for CourseCatalog. This class is responsible for obtaining course browse data.
 */
class CourseCatalogStore {

    state;

    constructor() {
        makeObservable(this, {
            state: observable
        });

        this.catalogData = [];
        this.exceptionUtils = appStore.getExceptionUtils();
    }

    /**
     * Fetch course catalog data.
     */
    loadCourseCatalogData = flow(function* () {
        // Update the aggregate state to pending.
        this.state = States.pending;

        if (this.catalogData.length != 0) {
            this.state = States.done;
            return;
        }

        if (appStore.isDebug()) {
            console.log("CourseCatalogStore: Starting data load.");
        }

        const operationName = "submitCatalogDataRequest";

        try {
            this.catalogData =  yield api.getSubjectAreaHierarchy();

            if (appStore.isDebug()) {
                console.log("CourseCatalogStore: Data load complete.");
            }
            feedbackMessagesStore.clearMessage(operationName);
            this.state = States.done;
        } catch (error) {
            // Set an error message with an operation id so that it can be cleared later if necessary.
            this.exceptionUtils.handleException(error, operationName);

            this.state = States.error;
        }
    });

    getCollegesForCampus(campusName) {
        const colleges = find(this.catalogData, function(item) { return item._name == campusName;});
        if (colleges) {
            return colleges._groups;
        }
    }
}

export default new CourseCatalogStore();